import { Carousel, ConfigProvider } from 'antd';

import AppCard1 from '../AppCards/AppCard1';
import InlineStyled from '../InlineStyled/InlineStyled';

const AppCarousel = ({ children, className = '' }) => {
  return (
    <AppCard1 className={className}>
      <ConfigProvider
        theme={{
          components: {
            Carousel: {
              /* here is your component tokens */
              dotActiveWidth: 5,
              dotGap: 2,
              dotHeight: 5,
              dotOffset: -54,
              dotWidth: 5,
            },
          },
        }}
      >
        <InlineStyled
          as={Carousel}
          autoplay
          $style={{
            '.slick-dots': {
              li: {
                borderRadius: '100%',
                background: '#e6f0ff',
                '&.slick-active': {
                  background: '#2E82FF',
                  button: {
                    background: '#2E82FF',
                  },
                  '&::after': {
                    background: 'transparent',
                  },
                },
              },
            },
          }}
        >
          {children}
        </InlineStyled>
      </ConfigProvider>
    </AppCard1>
  );
};

export default AppCarousel;
